import { render, staticRenderFns } from "./Reset.html?vue&type=template&id=5b3baf6f&scoped=true&"
import script from "./Reset.js?vue&type=script&lang=js&"
export * from "./Reset.js?vue&type=script&lang=js&"
import style0 from "./Reset.scss?vue&type=style&index=0&id=5b3baf6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3baf6f",
  null
  
)

export default component.exports